import React from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import SecondHero from "../components/SecondHero";
import { contactInfos } from "../data/contact-info";
import w6 from "../assets/w6.jpg";
const Contact = () => {
  return (
    <section className=" py-16 lg:py-20">
      {" "}
      <div className="max-screen ">
        <div className=" flex flex-col lg:flex-row flex-wrap shadow-2xl ">
          <div style={{ flex: "1 0 60%" }} className="order-4 lg:order-1">
            <iframe
              title="map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8449.616780976106!2d-82.18536309063387!3d27.07354358615395!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x679b36762259a007%3A0x48716d3420dbdda7!2sA%26L%20Landscaping!5e0!3m2!1sen!2sma!4v1692185540784!5m2!1sen!2sma"
              width="100%"
              height="450"
              style={{ border: "0" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"></iframe>
          </div>
          <div
            className="container py-12 bg-white order-1 lg:order-2 hidden lg:block"
            style={{ flex: "1 0 40%" }}>
            <h3 className="text-3xl font-semibold text-gray-700 mb-8">
              Bring nature in your home.
            </h3>
            <p className="text-gray-500 mb-4">
              We are available to chat via our website contact form, email or by
              phone! Contact us today!
            </p>
          </div>
          <div
            className="container bg-white py-8 order-2 lg:order-3"
            style={{ flex: "1 0 60%" }}>
            <h3 className="text-3xl font-semibold text-gray-700 mb-2">
              Get in touch
            </h3>
            <p className="text-gray-500 mb-4">Please fill the form below</p>
            <div>
              <div action="" className="bigContact-input text-xs">
                <InputFormLabel
                  label={"FULL NAME"}
                  name={"name"}
                  placeholder={"Name"}
                  type={"text"}
                  half={"half"}
                />
                <InputFormLabel
                  label={"EMAIL ADDRESS"}
                  name={"email"}
                  placeholder={"Email"}
                  type={"email"}
                  half={"half"}
                />
                <InputFormLabel
                  label={"SUBJECT"}
                  name={"subject"}
                  placeholder={"Subject"}
                  type={"text"}
                />
                <div className="mt-8">
                  <label
                    htmlFor={"message"}
                    className="font-semibold mb-0 mt-8">
                    MESSAGE
                  </label>
                  <textarea
                    name="message"
                    id=""
                    cols="10"
                    rows="5"
                    placeholder="Message"
                    className="py-4 bg-white text-gray-900 w-full border-b border-gray-300 focus:outline-none focus:border-b-2 focus:border-primary"></textarea>
                </div>

                <button className="btn btn-main uppercase my-6 text-base">
                  send message
                </button>
              </div>
            </div>
          </div>
          <div
            className="p-4 sm:p-8 bg-primary text-white  order-3 lg:order-4"
            style={{ flex: "1 0 40%" }}>
            <h3 className="text-3xl sm:text-4xl font-semibold text-white  mb-2">
              Professional & Reliable
            </h3>
            <p className="text-white mb-4 opacity-75 text-sm sm:text-base">
              We're open for any suggestion or just to have a chat!
            </p>
            <div className="sm:pt-6">
              <ul className="flex flex-col gap-6 text-sm sm:text-base break-all">
                {contactInfos.map((item, index) => {
                  return (
                    <li key={index}>
                      <div className="flex  gap-4 items-center">
                        {" "}
                        <div>
                          <span className="h-12 w-12 [&_*]:!w-8 sm:w-16 sm:h-16 sm:[&_*]:!w-auto  rounded-[50%] border border-[rgba(255,255,255,0.4)] flex justify-center items-center ">
                            {item.icon}
                          </span>
                        </div>
                        <div className="">
                          {item.title} :{" "}
                          <span className="opacity-75">{item.text}</span>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const InputFormLabel = ({
  type,
  name,
  value,
  handleChange,
  isDisabled,
  label,
  title,
  placeholder,
  half,
  onFocus,
  onBlur,
  onClick,
}) => {
  return (
    <div className={`flex flex-col   ${half}`}>
      <label htmlFor={name} className="font-semibold mb-0 mt-8">
        {label || name}{" "}
      </label>
      <input
        id={name}
        type={type}
        name={name}
        value={value}
        onChange={handleChange}
        disabled={isDisabled}
        className="py-4 bg-white text-gray-900 w-full border-b border-gray-300 focus:outline-none focus:border-b-2 focus:border-primary"
        title={title}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        onClick={onClick}
      />
    </div>
  );
};

const ContactPage = () => {
  return (
    <div>
      {" "}
      <Navbar />
      <SecondHero title={"Contact"} breadcrumb="Contact" img={w6} />
      <Contact />
      <Footer />
    </div>
  );
};

export default ContactPage;
